import {LocalStorageService} from "../../../../types/NgStorage";
import {DashboardViewConfiguration} from "../../models/DashboardViewConfiguration";
import {Optional} from "../../../../js/util/Optional";
import {IHttpService} from "angular";

const ConfigurationKey = "tfOmsDashboardConfiguration";

export class DashboardRepository {

    public static id = "dashboardRepository";

    /** @ngInject */
    public constructor(private readonly $localStorage: LocalStorageService,
                       private readonly $http: IHttpService) {
    }

    public async configuration(): Promise<Optional<DashboardViewConfiguration>> {
        const localConfig = this.$localStorage[ConfigurationKey];

        // Temporary upgrade code that will probably never be removed...
        if (localConfig != null) {
            this.updateConfiguration(localConfig);
            delete this.$localStorage[ConfigurationKey];
            return Optional.of(localConfig);
        } else {
            const url = "/tradefloor/api/dashboard-configuration";
            try {
                const response = await this.$http.get<DashboardViewConfiguration>(url);
                return Optional.of(response)
                               .map((r) => r.data)
                               .filter((c: any) => c !== ""); // No content returns an empty string
            } catch (e) {
                return Optional.empty();
            }
        }
    }

    public updateConfiguration(config: DashboardViewConfiguration) {
        try {
            const url = "/tradefloor/api/dashboard-configuration";
            this.$http.post(url, config, {ignoreLoadingBar: true});
        } catch (e) {

        }
    }
}
